import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import BannerFadeIn from "./../../components/bannerFadeIn";
import Flodeskform from "./../../components/flodeskForm";

import BackButton from './../../alpineComponents/backButton';
import CollectionBanner from './../../components/collectionBanner';
import BlogPostThumb from './../../components/blogPostThumb';
import BlogSideBar from './../../components/blogSideBar';
import {BlogPosts, BlogCategories} from './../../utils/blog';
import {GetUrlVariable} from './../../utils/constants';
import Footer from './../../components/footer';
import {Helmet} from "react-helmet";

export default class Blog extends Component {
  constructor(props) {
      super(props);
      this.state={
        posts:[]
      };
  }
  componentDidMount = () =>{
    this.setupPage()
  }
  componentDidUpdate = () =>{
    let category = GetUrlVariable('category');
    if(category != this.state.category){
      this.setupPage()
    }
  }
  setupPage = () =>{
    let category = GetUrlVariable('category');
    let categoryData;
    let posts = BlogPosts;
    let categories = [];
    if(category){
      categories = BlogCategories.filter((cat) => cat.slug == category)
      categoryData = categories[0];
      posts = BlogPosts.filter((post) => post.category && post.category.indexOf(category) != -1 )
    }
    this.setState({
      posts:posts,
      category:category,
      categoryData:categoryData
    })
  }
  render() {
    return (
      <div>
        <Helmet>
          <title>{'The Joys of Jet Lag | A Book Written by Kat Medina'}</title>
          <meta name="description" content="Live your best life, no matter where you are." />
        </Helmet>
        <BannerFadeIn>
          {this.state.categoryData ?
            <div className="large-padding background-image-fill" style={{backgroundImage:"url("+this.state.categoryData.image+")", paddingTop:"30vh", paddingBottom:"30vh"}}>
              <h1 className="white">{this.state.categoryData.name}</h1>
            </div>
          :
          <div className="large-padding background-image-fill" style={{backgroundImage:"url(/images/blog-joy.jpg)", paddingTop:"30vh", paddingBottom:"30vh"}}>
            <h1 className="white">{'Articles & Observations'}</h1>
          </div>
          }
        </BannerFadeIn>
        <div className="row">
          <div className="small-12 medium-8 large-9 medium-padding">
            {this.state.posts && this.state.posts.map((data) =>{
              return(
                <BlogPostThumb
                  title={data.title}
                  date={data.date}
                  description={data.description}
                  slug={data.slug}
                />
              )
            })}
          </div>
          <div className="small-12 medium-4 large-3 light-grey-background">
            <BlogSideBar />
          </div>
        </div>
        <ScrollFadeIn>
          <Flodeskform />
        </ScrollFadeIn>
        <Footer />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/blog/index.js